export default "__VITE_ASSET__UGOo2ZaO__"